import {
  type CLSMetric,
  type FCPMetric,
  type INPMetric,
  type LCPMetric,
  onCLS,
  onFCP,
  onINP,
  onLCP,
  onTTFB,
  type TTFBMetric,
} from 'web-vitals';

type WebVitalMetric =
  CLSMetric | INPMetric | LCPMetric | FCPMetric | TTFBMetric;

const reportWebVitals = (
  onPerfEntry?: (metric: WebVitalMetric) => void
): void => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    onCLS(onPerfEntry);
    onINP(onPerfEntry);
    onFCP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
  }
};

export default reportWebVitals;
